'use client';

import { HeldError } from '@storefront/shared-components/error-information/held-error';
import { RetryableError } from '@storefront/shared-components/error-information/retryable-error';
import { FlagsContext } from '@storefront/context/LDFlagsContext';
import ErrorClientWrapper from './error-client-wrapper';
import ErrorClientWrapperVisID from '../v2/(purchase)/error.p';
import { useContext } from 'react';

type ErrorProps = {
  error: RetryableError | HeldError;
  resetErrorBoundary?: () => unknown;
};

export default function CustomError({ error }: Readonly<ErrorProps>) {
  const { enableVisID } = useContext(FlagsContext);

  return enableVisID ? (
    <ErrorClientWrapperVisID error={error} />
  ) : (
    <ErrorClientWrapper error={error} />
  );
}
